import React from 'react'
import PropTypes from 'prop-types'
import { Button, Space, Tag } from 'antd'
import { FILTER_KEYS, chipLabel } from './query'

// What is filtering the list, visible without opening the drawer: one closable chip per active
// filter, with the name rather than the id, and Clear all. Draws nothing when nothing is active.
const ActiveFilters = ({ filters, options, onRemove, onClear }) => {
  const active = FILTER_KEYS.filter(key => filters[key])
  if (active.length === 0) return null
  return (
    <Space wrap size={[6, 6]} style={{ marginBottom: 12 }}>
      {active.map(key => (
        <Tag key={key} closable onClose={() => onRemove(key)}>
          {chipLabel(key, filters[key], options)}
        </Tag>
      ))}
      <Button type="link" size="small" onClick={onClear} style={{ padding: 0 }}>
        Clear all
      </Button>
    </Space>
  )
}

ActiveFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  options: PropTypes.object,
  onRemove: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
}

ActiveFilters.defaultProps = { options: {} }

export default ActiveFilters
